import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

interface ResponsiveImageProps {
  readonly alt: string;
  readonly height: number;
  readonly width: number;
  readonly src: string;
}

const ResponsiveImage = ({
  src,
  width,
  height,
  alt,
}: ResponsiveImageProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div className="my-12">
      <Image
        src={src}
        sizes="(min-width: 600px) 975px, (min-width: 420px) 600px, 420px"
        width={width}
        height={height}
        alt={t(alt)}
      />
    </div>
  );
};

export default ResponsiveImage;
